import CopyToClipboard from "react-copy-to-clipboard";
import {
  useMemo,
  type FunctionComponent,
} from "react";
import clsx from "clsx";
import IconFb from "../Icon/IconFb";
import IconX from "../Icon/IconX";
import IconLink from "../Icon/IconLink";
import type {
  PostPubSchemaWithContentType,
  PostSingleWithContentType,
} from "~/database/post.model";
import type { loader } from "./../../root";
import {
  generateShareUrlFB,
  generateShareUrlTwitter,
} from "~/utils/shareSns";
import {
  useLocation,
  useRouteLoaderData,
} from "@remix-run/react";
import toast from "react-hot-toast";

interface PostActionListProps {
  post:
    | PostSingleWithContentType
    | PostPubSchemaWithContentType;
}

const PostActionList: FunctionComponent<
  PostActionListProps
> = ({ post }) => {
  const navigation = useLocation();

  const root =
    useRouteLoaderData<typeof loader>("root");

  const shareURL = useMemo(() => {
    return (
      root?.ENV.SITE_URL + navigation.pathname
    );
  }, [navigation.pathname, root?.ENV.SITE_URL]);
  return (
    <div
      className={clsx(
        "flex",
        "items-center",
        "gap-13",
      )}
    >
    {/*   <div
        className={clsx(
          "flex",
          "items-center",
          "text-15",
          "gap-5",
        )}
      >
        <div className={clsx("w-18")}>
          <FavoBtn
            isFavo={post.is_liked}
            postId={post.id}
          ></FavoBtn>
        </div>
        <div
          className={clsx(
            "text-14",
            "leading-[1]",
          )}
        >
          {post.likes_count}
        </div>
      </div> */}
      <div className={clsx("w-20")}>
        <a
          href={generateShareUrlTwitter(
            post.title,
            shareURL,
          )}
          target="_blank"
          rel="noreferrer"
        >
          <IconX></IconX>
        </a>
      </div>
      <div className={clsx("w-20")}>
        <a
          href={generateShareUrlFB(shareURL)}
          target="_blank"
          rel="noreferrer"
        >
          <IconFb></IconFb>
        </a>
      </div>
      <button className={clsx("cursor-pointer")}>
        <CopyToClipboard
          text={shareURL}
          onCopy={() => {
            toast.success(
              "URLがコピーされました！",
            );
          }}
        >
          <div className={clsx("w-20")}>
            <IconLink></IconLink>
          </div>
        </CopyToClipboard>
      </button>
    </div>
  );
};

export default PostActionList;
